import type { FaireProductEntity } from "../../entity_types/product";

export const p_w5a9uu7aau: FaireProductEntity = {
  token: "p_w5a9uu7aau",
  type: "product",
  name: "6\" x 6\" x 4\" Shipping Boxes - Bundle of 25",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/ff4d3291aaecfa2630d8099c4bd8efa3fe5762b6f676ae8453317ca828e1e986.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Compact 6\" x 6\" x 4\" corrugated shipping boxes for accessories, gifts and other small, lightweight merchandise. The smaller size keeps items secure while cutting down on empty space and extra packing material.\n\n- Size: 6\" L x 6\" W x 4\" H\n- Material: corrugated\n- Easy to assemble for fast packing\n- Quantity: 25 boxes per bundle\n\nA practical everyday box for boutiques, online sellers, stockrooms and fulfillment areas shipping small orders.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:07.273Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
